import * as React from "react";
type CalendarForwardProps = {
  fillColor: string;
  pathColor: string;
} & React.SVGProps<SVGSVGElement>;

const CalendarBack = ({
  fillColor,
  pathColor,
  ...props
}: CalendarForwardProps) => (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={35.3145}
      y={35.3213}
      width={34.9471}
      height={34.9511}
      rx={6.75}
      transform="rotate(180 35.3145 35.3213)"
      fill={fillColor}
      stroke="#DFE4EA"
      strokeWidth={0.5}
    />
    <path
      d="M21.1061 25.1574C20.9327 25.1574 20.7593 25.0996 20.6438 24.9551L14.113 18.308C13.853 18.0479 13.853 17.6433 14.113 17.3832L20.6438 10.7361C20.9038 10.476 21.3084 10.476 21.5685 10.7361C21.8285 10.9962 21.8285 11.4008 21.5685 11.6609L15.5001 17.8456L21.5974 24.0303C21.8574 24.2904 21.8574 24.695 21.5974 24.9551C21.424 25.0707 21.2795 25.1574 21.1061 25.1574Z"
      fill={pathColor}
    />
  </svg>
);
export default CalendarBack;
